import React from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import SwitchForm from '../../../../components/SwitchForm';
import ImageAndVideoUploadForm from '../../../../../../../components/form/ImageAndVideoUploadForm';
import CountOfTotal from '../../../../../../../components/CountOfTotal';
import { formRequiredRules } from '../../../../../../../lib/formRules';
import { EventSectionAttachment } from '../../../../../../../types/query/event';
import { MAXIMUM_NUMBER_OF_EVENT_SWIPE_SECTION_TYPE_IMG } from '../../../../../../../constants/service/app/eventConstants';
import { SwipeSectionStyle } from './style';

interface SwipeSectionProps extends FormComponentProps {
  name: string;
  isInfinity?: boolean;
  sectionAttachmentList?: EventSectionAttachment[];
}
const SwipeSection = (props: SwipeSectionProps) => {
  const { form, name, isInfinity, sectionAttachmentList } = props;
  const attachments = form.getFieldValue(`${name}-attachments`);

  return (
    <SwipeSectionStyle>
      <SwitchForm
        className="event-swipe-section-infinity-toggle"
        form={form}
        label="스와이프 인피니티 여부"
        name={`${name}-isInfinity`}
        initialValue={isInfinity}
      />
      <ImageAndVideoUploadForm
        vertical={true}
        name={`${name}-attachments`}
        form={form}
        modalTitle="기획전 섹션 이미지"
        label={
          <span>
            기획전 섹션 이미지
            <CountOfTotal content={attachments} maxCnt={MAXIMUM_NUMBER_OF_EVENT_SWIPE_SECTION_TYPE_IMG} />
          </span>
        }
        rules={[formRequiredRules(true, '필수 정보입니다.', false, 'array')]}
        initialValue={sectionAttachmentList}
        maxCnt={MAXIMUM_NUMBER_OF_EVENT_SWIPE_SECTION_TYPE_IMG}
        multiple
      />
    </SwipeSectionStyle>
  );
};

export default SwipeSection;
